export const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const FALLBACK_LANGUAGE: SupportedLanguage = 'en';

export const DEFAULT_NAMESPACE = 'common';

const SUPPORTED_LANGUAGE_SET: ReadonlySet<string> = new Set(SUPPORTED_LANGUAGES);

export const isSupportedLanguage = (value: unknown): value is SupportedLanguage =>
  typeof value === 'string' && SUPPORTED_LANGUAGE_SET.has(value);

export const resolveLanguage = (...candidates: unknown[]): SupportedLanguage =>
  candidates.find(isSupportedLanguage) ?? FALLBACK_LANGUAGE;

export default {
  supportedLngs: [...SUPPORTED_LANGUAGES],
  fallbackLng: FALLBACK_LANGUAGE,
  defaultNS: DEFAULT_NAMESPACE,
  react: { useSuspense: false },
};
